import * as React from 'react';
import FirstLetterIcon from './FirstLetterIcon.js';
import classNames from 'classnames';
import Conditional from '../../misc/Conditional/index.js';
import { getAbsoluteLink } from '../helpers.js';
var LoggedInMenuHeader = function LoggedInMenuHeader(_ref) {
  var username = _ref.username,
    profileLink = _ref.profileLink,
    profileLinkFunction = _ref.profileLinkFunction;
  return /* @__PURE__ */React.createElement("header", {
    className: "header-cp__logged-in-menu-header"
  }, /* @__PURE__ */React.createElement(FirstLetterIcon, {
    word: username
  }), /* @__PURE__ */React.createElement("div", {
    className: "header-cp__logged-in-menu-header-text"
  }, /* @__PURE__ */React.createElement("p", {
    className: "header-cp__logged-in-menu-header-name"
  }, username), /* @__PURE__ */React.createElement(Conditional, {
    condition: !!profileLinkFunction,
    renderIf: /* @__PURE__ */React.createElement("button", {
      onClick: profileLinkFunction,
      className: "header-cp__logged-in-menu-header-profile header-cp__logged-in-menu-header-profile--button",
      "data-clicked": "logged-header-menu-profile-link"
    }, "Editar perfil"),
    renderElse: /* @__PURE__ */React.createElement("a", {
      href: getAbsoluteLink(profileLink),
      className: "header-cp__logged-in-menu-header-profile",
      "data-clicked": "logged-header-menu-profile-link"
    }, "Editar perfil")
  })));
};
var LoggedInNavigation = function LoggedInNavigation(_ref2) {
  var username = _ref2.username,
    loggedMenuLinks = _ref2.loggedMenuLinks,
    profileLinkFunction = _ref2.profileLinkFunction;
  var getItemClass = function getItemClass(separator) {
    return classNames("header-cp__logged-links-item", {
      "header-cp__logged-links-item--separator": !!separator
    });
  };
  var profileLink = "/perfil/";
  return /* @__PURE__ */React.createElement("div", {
    className: "header-cp__logged-in-navigation"
  }, /* @__PURE__ */React.createElement("div", {
    className: "header-cp__logged-in-desk-name-holder"
  }, /* @__PURE__ */React.createElement(FirstLetterIcon, {
    word: username,
    customModifier: "desk-external"
  }), /* @__PURE__ */React.createElement("p", {
    className: "header-cp__logged-in-desk-name"
  }, username), /* @__PURE__ */React.createElement("svg", {
    viewBox: "0 0 9.7 5.7",
    className: "header-cp__logged-in-arrow-down"
  }, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: ".5",
    d: "M8.8.4L4.9 4.2.9.4.4.9l4.5 4.5L9.4.9z"
  }))), /* @__PURE__ */React.createElement("div", {
    className: "header-cp__logged-menu"
  }, /* @__PURE__ */React.createElement(LoggedInMenuHeader, {
    username: username,
    profileLink: profileLink,
    profileLinkFunction: profileLinkFunction
  }), /* @__PURE__ */React.createElement("div", {
    className: "header-cp__logged-menu-actions"
  }, /* @__PURE__ */React.createElement("ul", {
    className: "header-cp__logged-links-list"
  }, loggedMenuLinks.map(function (_ref3, index) {
    var label = _ref3.label,
      separator = _ref3.separator,
      rawIcon = _ref3.rawIcon,
      path = _ref3.path,
      onClick = _ref3.onClick,
      isActive = _ref3.isActive;
    return /* @__PURE__ */React.createElement("li", {
      className: getItemClass(separator),
      key: "logged-in-menu-item-".concat(index)
    }, /* @__PURE__ */React.createElement(ItemLink, {
      path: path,
      onClick: onClick,
      label: label,
      isActive: isActive
    }, /* @__PURE__ */React.createElement(Conditional, {
      condition: !!rawIcon,
      renderIf: /* @__PURE__ */React.createElement("div", {
        className: "header-cp__logged-links-icon-holder",
        dangerouslySetInnerHTML: {
          __html: rawIcon
        }
      })
    }), label));
  })))));
};
var ItemLink = function ItemLink(_ref4) {
  var path = _ref4.path,
    label = _ref4.label,
    onClick = _ref4.onClick,
    children = _ref4.children,
    isActive = _ref4.isActive;
  var linkClass = classNames("header-cp__logged-links-link", {
    "header-cp__logged-links-link--button": !path,
    "header-cp__logged-links-link--active": isActive
  });
  return /* @__PURE__ */React.createElement(Conditional, {
    condition: !!path,
    renderIf: /* @__PURE__ */React.createElement("a", {
      href: getAbsoluteLink(path),
      className: linkClass,
      "data-clicked": "header-logged-menu-item-".concat(label),
      onClick: onClick
    }, children),
    renderElse: /* @__PURE__ */React.createElement("button", {
      className: linkClass,
      "data-clicked": "header-logged-menu-item-".concat(label),
      onClick: onClick
    }, children)
  });
};
export { LoggedInNavigation as default };